import React, { Component } from "react";
import './Financial.css'
import { AddForm } from './AddForm'

export class Financial extends Component {

    constructor(props) {
        super(props);
        this.state = { loading: false, entryPayment: [], exitPayment: [], currentTab: 1, cuadre: 0, startDate: null, endDate: null, processNumber: '', city: '', totalEfecty: 0, totalBank: 0, processId:0 };
    }

    componentDidMount() {
        //this.pageLoad();
        window.cuadre = 0;
    }

    componentDidUpdate() {
        //window.cuadre = 0;
    }

    componentWillUpdate(nextProps, nextState) {
        window.cuadre = 0;
    }

    async pageLoad() {

        //this.setState({ isPost: true })

        //if (!this.state.startDate || !this.state.endDate) {
        //    return;
        //}

        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        this.setState({ loading: true });

        let response = await fetch(`Financial/Get?${this.state.startDate ? `startDate=${this.state.startDate}` : `startDate=`}&${this.state.endDate ? `endDate=${this.state.endDate}` : `endDate=`}&processId=${this.state.processId}&processNumber=${this.state.processNumber}&city=${this.state.city}`, request);
        this.setState({ loading: false });

        if (response.status == 401) {
            alert('No está autorizado para esta operación.');
        }

        if (response.status == 200) {
            window.cuadre = 0;
            let data = await response.json();
            this.setState({ entryPayment: data.entry, exitPayment: data.exit });
        }
    }

    async downloadExcel() {

        //this.setState({ isPost: true })

        //if (!this.state.startDate || !this.state.endDate) {
        //    return;
        //}

        const request = {
            method: 'GET',
            headers: {
                'Content-type': 'application/json',
                'Authorization': `bearer ${localStorage.getItem('token')}`
            }
        }

        this.setState({ buttonLoading: true });

        let response = await fetch(`Financial/downloadExcel?${this.state.startDate ? `startDate=${this.state.startDate}` : `startDate=`}&${this.state.endDate ? `endDate=${this.state.endDate}` : `endDate=`}&processId=${this.state.processId}&processNumber=${this.state.processNumber}&city=${this.state.city}&currentTab=${this.state.currentTab}`, request);
        this.setState({ buttonLoading: false });

        if (response.status == 401) {
            alert('No está autorizado para esta operación.');
        }

        if (response.status == 200) {
            let data = await response.json();
            window.location.href = data.path;
            //this.setState({ entryPayment: data.entry, exitPayment: data.exit });
        }
    }

    formatCurrency(val) {

        var formatted = new Intl.NumberFormat('es-CO', {
            style: 'currency',
            currency: 'COP',
            minimumFractionDigits: 2
        }).format(val);
        return <label className={formatted.indexOf('-') != -1 ? 'en-rojo' : 'saldo-ok'}> {formatted}</ label>;
    }

    GetTotalEfecty(process) {
        var efectyEntry = process.filter(c => c.wayToPay == 'Efectivo');
        var efectyExit;
        var exit = this.state.exitPayment.filter(a => a.processId == process[0].processId);
        if (exit && exit.length > 0) {
            efectyExit = exit[0].details.filter(c => c.wayToPay == 'Efectivo');
        }
        var efectyTotal = efectyEntry && efectyEntry.length > 0 ? efectyEntry.map(h => h.payment).reduce((a, b) => a + b) : 0;
        var efectyTotalExit = efectyExit && efectyExit.length > 0 ? efectyExit.map(h => h.payment).reduce((a, b) => a + b) : 0;

        //this.setState({ cuadre: (efectyTotal - efectyTotalExit) });
        window.cuadre = window.cuadre + (efectyTotal - efectyTotalExit);

        return this.formatCurrency(efectyTotal - efectyTotalExit);
    }

    GetTotalBanck(process) {
        var banckEntry = process.filter(c => c.wayToPay != 'Efectivo');
        var banckExit;
        var exit = this.state.exitPayment.filter(a => a.processId == process[0].processId)

        if (exit && exit.length > 0) {
            banckExit = exit[0].details.filter(c => c.wayToPay != 'Efectivo');
        }
        var banckTotal = banckEntry && banckEntry.length > 0 ? banckEntry.map(h => h.payment).reduce((a, b) => a + b) : 0;
        var banckTotalExit = banckExit && banckExit.length > 0 ? banckExit.map(h => h.payment).reduce((a, b) => a + b) : 0;

        //this.setState({ cuadre: (banckTotal - banckTotalExit) });
        window.cuadre = window.cuadre + (banckTotal - banckTotalExit);
        return this.formatCurrency(banckTotal - banckTotalExit);
    }

    handleSelectProcess(event) {
        document.querySelector('#searchProcess').value = '';
        this.state.processId = parseInt(event.currentTarget.dataset.id);
        this.setState({ processNameSelected: event.currentTarget.value, processFind: [] });
    }

    removeSelectProcess(event) {
        this.state.processId = 0;
        this.setState({ processNameSelected: '', processFind: [] });
    }

    async getProcess(event) {
        this.state.processFind = [];
        if (event.currentTarget.value && event.currentTarget.value.length > 2) {
            this.setState({ loading: true, currentInput: event.currentTarget });
            const request = {
                method: 'GET',
                headers: {
                    'Content-type': 'application/json',
                    'Authorization': `bearer ${localStorage.getItem('token')}`
                }
            }
            event.currentTarget.focus();
            let response = await fetch(`Process/GetProcessByLike?param=${event.currentTarget.value}`, request);
            if (response.redirected) {
                window.location.href = response.url;
            }
            this.setState({ loading: false });
            if (response.status == 200) {
                let data = await response.json();
                this.setState({ processFind: data });
                this.state.currentInput.focus();
            }
            else {
                alert('Error obteniendo los procesos');
            }

        }
    }

    static renderPage(context) {
        var show = false;
        return (
            <div>
                <ul class="nav nav-tabs">
                    <li class="nav-item">
                        <a class="nav-link home active" aria-current="page" onClick={(event) => {
                            context.setState({ currentTab: 1 });
                            window.cuadre = 0;
                            document.querySelectorAll('.nav.nav-tabs .nav-item a').forEach((a, i) => { a.classList.remove('active') })
                            event.currentTarget.classList.add('active');
                        }}>Ingreso</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" onClick={(event) => {
                            context.setState({ currentTab: 2 });
                            document.querySelectorAll('.nav.nav-tabs .nav-item a').forEach((a, i) => { a.classList.remove('active') })
                            event.currentTarget.classList.add('active');
                        }}>Egreso</a>
                    </li>
                    <li class="nav-item">
                        <a class="nav-link" onClick={(event) => {
                            context.setState({ currentTab: 3 });
                            document.querySelectorAll('.nav.nav-tabs .nav-item a').forEach((a, i) => { a.classList.remove('active') })
                            event.currentTarget.classList.add('active');
                        }}>Agregar</a>
                    </li>
                </ul>

                {context.state.entryPayment && context.state.currentTab == 1 ?
                    context.state.entryPayment.map((e) => {

                        return <div id="accordion">
                            <div className="card">
                                <div className="card-header" id={`heading${e[0].id}`}>
                                    <h5 className="mb-0">
                                        <button className="btn btn-prymary collapsable" data-toggle="collapse" data-target={`#collapse${e[0].id}`} aria-expanded="true" aria-controls="collapseOne">
                                            <div className="row">
                                                <span className="col-lg-6"><b>Proceso:</b> {e[0].processName}</span>
                                                <span className="col-lg-6"><b>Total:</b> {context.formatCurrency(e.map(v => v.payment).reduce((a, b) => a + b))}</span>
                                            </div>
                                            <div className="row">
                                                <div className="col-lg-6">
                                                    <small><b>Saldo en efectivo: </b> {context.GetTotalEfecty(e)} </small>
                                                    <small><b>Saldo en banco: </b> {context.GetTotalBanck(e)}</small>
                                                </div>
                                                <div className="col-lg-6">
                                                    <small><b>Total en efectivo: </b>
                                                        {
                                                            e.filter(c => c.wayToPay == 'Efectivo').length > 0 ? context.formatCurrency(e.filter(c => c.wayToPay == 'Efectivo').map(p => p.payment).reduce((a, b) => a + b)) : context.formatCurrency(0)
                                                        }
                                                    </small>
                                                    <small><b>Total en banco: </b>
                                                        {
                                                            e.filter(c => c.wayToPay != 'Efectivo').length > 0 ? context.formatCurrency(e.filter(c => c.wayToPay != 'Efectivo').map(p => p.payment).reduce((a, b) => a + b)) : context.formatCurrency(0)
                                                        }
                                                    </small>
                                                </div>
                                            </div>
                                        </button>
                                    </h5>
                                </div>

                                <div id={`collapse${e[0].id}`} class={`collapse ${show ? 'show' : 'collapsed'}`} aria-labelledby="headingOne" data-parent="#accordion">
                                    <div className="card-body">
                                        {show = false}
                                        <div className="accordion-body">
                                            {e.map((a) => {
                                                return <div className="detail">
                                                    <span><b>Id: </b>{a.id}</span>
                                                    <span><b>Usuario: </b>{a.clientName}</span>
                                                    <span><b>Tipo de pago: </b>{a.paymentType}</span>
                                                    <span><b>Medio de pago: </b>{a.wayToPay}</span>
                                                    <span><b>Valor: </b>{context.formatCurrency(a.payment)}</span>
                                                    <span><b>Fecha: </b>{a.createOnDate}</span>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })

                    : null}


                {context.state.exitPayment && context.state.currentTab == 2 ?

                    context.state.exitPayment.map((e) => {
                        return <div id="accordion">
                            <div className="card">
                                <div className="card-header" id={`heading${e.processId}`}>
                                    <h5 className="mb-0">
                                        <button className="btn btn-prymary collapsable" data-toggle="collapse" data-target={`#collapse${e.processId}`} aria-expanded="true" aria-controls="collapseOne">
                                            <div className="row">
                                                <span className="col-lg-6"><b>Proceso:</b> {e.details[0].processName}</span>
                                                <span className="col-lg-6"><b>Total:</b> {context.formatCurrency(e.details.map(v => v.payment).reduce((a, b) => a + b))}</span>
                                            </div>
                                        </button>
                                    </h5>
                                </div>

                                <div id={`collapse${e.processId}`} class={`collapse ${show ? 'show' : 'collapsed'}`} aria-labelledby="headingOne" data-parent="#accordion">
                                    <div className="card-body">
                                        {show = false}
                                        <div className="accordion-body">
                                            {e.details.map((a) => {
                                                return <div className="detail">
                                                    <span><b>Id: </b>{a.id}</span>
                                                    <span><b>Medio de pago: </b>{a.wayToPay}</span>
                                                    <span><b>Valor: </b>{context.formatCurrency(a.payment)}</span>
                                                    <span><b>Fecha: </b>{a.registerDate}</span>
                                                </div>
                                            })}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    })

                    : null}


                {context.state.currentTab == 3 ? <AddForm reLoad={() => {
                    window.cuadre = 0;
                    context.pageLoad();
                    context.setState({ currentTab: 1 });

                    //document.querySelectorAll('.nav.nav-tabs .nav-item a').forEach((a, i) => { a.classList.remove('active') })
                    //document.querySelector('.nav.nav-tabs .nav-item .home').classList.add('active');
                }} /> : null}
            </div>
        )
    }

    render() {

        let content = this.state.loading ? <h4>Cargando...</h4> : Financial.renderPage(this);
        let isPageLoad = false;

        return (
            <div>
                <h2>Modulo financiero</h2>

                <div className="form-group row">
                    <div className="col-lg-6">
                        <label>Fecha de inicio</label>
                        <input type="date" className="form-control" onBlur={(e) => { this.setState({ startDate: e.currentTarget.value }) }} />
                        {!this.state.startDate && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                    </div>
                    <div className="col-lg-6">
                        <label>Fecha de inicio</label>
                        <input type="date" className="form-control" onBlur={(e) => { this.setState({ endDate: e.currentTarget.value }) }} />
                        {!this.state.endDate && this.state.isPost ? <span className="error required">Campo requerido</span> : null}
                    </div>
                    <div className="col-lg-4">
                        <label>N&uacute;mero de proceso</label>
                        <input type="text" className="form-control" onBlur={(e) => { this.setState({ processNumber: e.currentTarget.value }) }} />
                    </div>


                    <div className="col-lg-4">
                        <label>Proceso</label>

                        {!this.state.processNameSelected ?
                            <input type="text" id="searchProcess" className="form-control" disabled={this.state.loading} onChange={(event) => { this.getProcess(event) }} /> :
                            null
                        }

                        {this.state.processNameSelected ?
                            <div className="form-control">
                                <span>{this.state.processNameSelected}</span>
                                <span className="remove" onClick={() => { this.removeSelectProcess() }} title="Eliminar filtro">x</span>
                            </div> :
                            null
                        }

                        {this.state.loading ? <span>Por favor espere...</span> : null}

                        {this.state.processFind ? this.state.processFind.map((e) => <ul>
                            <input type="button" value={e.description} data-id={e.id} data-processNumber={e.processNumber} onClick={(event) => { this.handleSelectProcess(event) }} />
                        </ul>) : null}

                    </div>


                    <div className="col-lg-4" hidden>
                        <label>Proceso</label>
                        <input type="text" className="form-control" onBlur={(e) => { this.setState({ processId: e.currentTarget.value }) }} />
                    </div>
                    <div className="col-lg-4">
                        <label>Ciudad</label>
                        <select className="form-control" onChange={(e) => { this.setState({ city: e.currentTarget.value }) }}>
                            <option value="">Todos</option>
                            <option value="Medellín">Medellín</option>
                            <option value="Rionegro">Rionegro</option>
                            <option value="Bogotá">Bogotá</option>
                        </select>
                    </div>
                </div>
                <div className="form-group row">
                    <div className="col-lg-12">
                        <input type="button" className="btn btn-primary" value="Buscar" onClick={() => { this.pageLoad(); }} />
                    </div>
                </div>
                <b>Cuadre de caja: </b> {this.formatCurrency(window.cuadre)}
                <div className="col-lg-12">
                    <input type="button" className="btn btn-primary" disabled={this.state.buttonLoading} value={this.state.buttonLoading ? "Por favor espere..." : "Descargar excel"} onClick={() => { this.downloadExcel(); }} />
                </div>
                {content}
            </div>
        )
    }
}